import { ContentBlockForm } from "@components/content_block/content_block_form";
import { Loader } from "@components/loader/loader";
import { useFetchContentBlock } from "@hooks/use_fetch_content_block";
import { isNil } from "@services/typed_helpers";
import React, { type FC, type ReactNode } from "react";

interface ContentBlockEditPageProps {
  id?: string;
}

const ContentBlocksEditPage: FC<ContentBlockEditPageProps> = ({ id }) => {
  const { contentBlock, loading } = useFetchContentBlock({ id });
  const isNewContentBlock = !loading && contentBlock && isNil(contentBlock?.id);
  let title: ReactNode;

  if (loading) {
    return <Loader />;
  }
  if (!contentBlock) {
    return null;
  }

  if (isNewContentBlock) {
    title = "Add Content Block";
  }

  if (contentBlock?.id && contentBlock?.page) {
    title = (
      <>
        Edit Content Block &quot;{contentBlock.page}
        {contentBlock.section ? <>&mdash;{contentBlock.section}</> : null}&quot;
      </>
    );
  }

  return (
    <div className="content">
      <header>
        <h1>{title}</h1>
      </header>
      <ContentBlockForm contentBlock={contentBlock} />
    </div>
  );
};

export { ContentBlocksEditPage };
